var map = {
	"./PaellaCorePlugins.js": 1481,
	"./es.upv.paella.canvasButtonPluginTest.js": 7927,
	"./es.upv.paella.collisionTestShortucts.js": 6384,
	"./es.upv.paella.defaultShortcuts.js": 5026,
	"./es.upv.paella.dynamicWidthButton.js": 9911,
	"./es.upv.paella.nonInteractiveButtonTest.js": 4961,
	"./es.upv.paella.playPauseButton.js": 3591,
	"./es.upv.paella.testButtonGroupPlugin.js": 7858,
	"./es.upv.paella.testCaptionsPlugin.js": 2694,
	"./es.upv.paella.testEventLogPlugin.js": 5651,
	"./es.upv.paella.testFoldableButton.js": 3508,
	"./es.upv.paella.testPopUp2Button.js": 7924,
	"./es.upv.paella.testPopUpButton.js": 9061,
	"./es.upv.paella.testProgressIndicatorPlugin.js": 2786,
	"./es.upv.paella.testVideoContainerButton.js": 8539,
	"./es.upv.paella.vttManifestCaptionsPlugin.js": 6761
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 591;